module.exports = __webpack_public_path__ + "static/media/businessCards.88339a93.jpg";